<template>
  <div>
    <div class="columns is-mobile is-multiline is-hidden-tablet">
      <div v-if="isEditable" class="column is-2">
        <span
          class="icon minus-icon mr-2"
          :class="{ 'icon-disabled': minAmountLimit }"
          @click="decreaseAmount()"
        >
          <i class="fas fa-minus-circle"></i>
        </span>
      </div>
      <div class="column is-8">
        <span class="has-text-centered amount">{{ productAmount }}</span>
      </div>
      <div v-if="isEditable" class="column is-2">
        <span
          class="icon plus-icon ml-2"
          :class="{ 'icon-disabled': maxAmountLimit }"
          @click="increaseAmount()"
        >
          <i class="fas fa-plus-circle"></i>
        </span>
      </div>
    </div>

    <div class="columns is-multiline is-hidden-mobile">
      <div class="column is-12 amount-controls">
        <span
          v-if="isEditable"
          class="icon minus-icon"
          :class="{ 'icon-disabled': minAmountLimit }"
          @click="decreaseAmount()"
        >
          <i class="fas fa-minus"></i>
        </span>
        <span class="has-text-centered amount">{{ productAmount }}</span>
        <span
          v-if="isEditable"
          class="icon plus-icon"
          :class="{ 'icon-disabled': maxAmountLimit }"
          @click="increaseAmount()"
        >
          <i class="fas fa-plus"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "productAmount",
  props: ["modelValue", "isEditable", "id", "item"],
  data() {
    return {
      productAmount: this.modelValue,
      productPrices: this.$store.getters.getVolumesDiscount(this.item.product),
    };
  },
  methods: {
    ...mapGetters({
      getVolumesDiscount: "getVolumesDiscount",
      getProductById: "getProductById",
      getSavedItems: "getSavedItems",
    }),
    increaseAmount() {
      let product = this.$store.getters.getProductById(this.item.product)
      if (product == undefined) {
        return
      }
      if (product.resource_type == "StoreProduct" || product.resource_type == "Lid") {
        this.productAmount += 1
        this.$emit("amountupdated", this.item.id, this.productAmount);
      } else if (product.resource_type == "Plate") {
        this.productAmount = this.item.amount + 500;
        this.$emit("update:modelValue", this.productAmount);
        if (this.item != null) {
          this.$emit("amountupdated", this.item.id, this.productAmount);
        }
      } else {
        let currentIndex = this.productPrices.findIndex(
          (a) => a.volume_point == this.productAmount
        );
        if (this.productPrices[currentIndex + 1]) {
          this.productAmount =
            this.productPrices[currentIndex + 1].volume_point;
          this.$emit("update:modelValue", this.productAmount);
          if (this.item != null) {
            this.$emit("amountupdated", this.item.id, this.productAmount);
          }
        } else {
          // Max amount reached
        }
      }
    },
    decreaseAmount() {
      let product = this.$store.getters.getProductById(this.item.product)
      if (product == undefined) {
        return
      }
      if (product.resource_type == "StoreProduct" || product.resource_type == "Lid") {
        if (this.item.amount == 1) {
          this.productAmount = 1
          this.$emit("amountupdated", this.item.id, this.productAmount);
        } else {
          if (this.item.amount > 1) {
            this.productAmount -= 1
            console.log("emit decrease")
            this.$emit("amountupdated", this.item.id, this.productAmount);
          }
        }
      } else if (product.resource_type == "Plate") {
        if (this.item.amount - 500 > 0) {
          this.productAmount = this.item.amount - 500;
          this.$emit("update:modelValue", this.productAmount);
          if (this.item != null) {
            this.$emit("amountupdated", this.item.id, this.productAmount);
          }
        }
      } else {
        let currentIndex = this.productPrices.findIndex(
          (a) => a.volume_point == this.productAmount
        );
        if (this.productPrices[currentIndex - 1]) {
          this.productAmount =
            this.productPrices[currentIndex - 1].volume_point;
          this.$emit("update:modelValue", this.productAmount);
          if (this.item != null) {
            this.$emit("amountupdated", this.item.id, this.productAmount);
          }
        } else {
          // Min amount reached
        }
      }
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    maxAmountLimit() {
      let product = this.$store.getters.getProductById(this.item.product)
      if (product == undefined) {
        return false
      }
      if (["Lid", "Plate", "StoreProduct"].includes(product.resource_type)) {
        // lid, plate doesnt have max amount
        return false;
      }
      let currentIndex = this.productPrices.findIndex(
        (a) => a.volume_point == this.productAmount
      );
      if (currentIndex + 1 == this.productPrices.length) {
        // Max amount
        return true;
      }
      return false;
    },
    minAmountLimit() {
      let product = this.$store.getters.getProductById(this.item.product)
      if (product == undefined) {
        return false
      }
      if (product.resource_type == "Plate" && this.productAmount == 500) {
        return true;
      }
      let currentIndex = this.productPrices.findIndex(
        (a) => a.volume_point == this.productAmount
      );
      if (currentIndex == 0) {
        // Min amount
        return true;
      }
      return false;
    },
    has_cups() {
      for (let i = 0; i < this.getSavedItems().length; i++) {
        let product = this.$store.getters.getProductById(this.getSavedItems()[i].product)
        if (product.resource_type == "Cup") {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@use "../assets/sass/variables" as *;

.amount {
  display: inline-block;
  min-width: 3em;
  font-size: 18px;
  font-family: Ubuntu;
  width: 100%;
  text-align: center;
}

.amount-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #666666;
  margin-top: 10px;
  margin-left: 10px;
}

.plus-icon {
  left: -24px;
}

.icon:hover {
  cursor: pointer;
  color: #f4acbc;
}

.red {
  color: red !important;
}

.bubble {
  position: absolute;
  padding: 5px 10px 5px 10px;
  background: #ffffff;
  border: 1px solid red;
  font-size: 10px;
  color: red;
  top: -15px;
  right: 60px;
  @media only screen and (min-width: 1100px) {
    right: 11px;
  }
  @media screen and (max-width: 1215px) and (min-width: 768px) {
    right: 44px;
    font-size: 12px;
  }
}

span {
  svg {
    color: $pyroll-violet;
    font-size: 30px;
  }
}

.icon-disabled {
  cursor: not-allowed !important;
  svg {
    color: #dddddd;
  }
}
</style>
